import { render } from "./location-select.vue?vue&type=template&id=8735f54c&scoped=true"
import script from "./location-select.vue?vue&type=script&lang=js"
export * from "./location-select.vue?vue&type=script&lang=js"

import "./location-select.vue?vue&type=style&index=0&id=8735f54c&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8735f54c"]])

export default __exports__